import {
    ADMIN_USER_LOGOUT_START,
    ADMIN_USER_LOGOUT_SUCCESS,
    ADMIN_USER_LOGOUT_ERROR,
    SET_RUNTIME_VARIABLE
} from '../../constants';

import { adminUserLogout as query } from '../../lib/graphql';
import { removeCookies, logoutAllTabs } from '../../helpers/cookies';

export function adminLogout() {
    return async (dispatch, getState, { client }) => {
        try {
          
            dispatch({
                type: ADMIN_USER_LOGOUT_START
            })
    
            const { data } = await client.query({
                query,
                fetchPolicy: 'network-only'
            })
            
            if (data?.adminUserLogout?.status === 200) {
                // Update Redux state first
                dispatch({
                    type: ADMIN_USER_LOGOUT_SUCCESS
                })

                dispatch({
                    type: SET_RUNTIME_VARIABLE,
                    payload: {
                        name: 'isAdminAuthenticated',
                        value: false
                    }
                })
                
                // Trigger logout across all tabs
                logoutAllTabs();
                
                // Set a flag to prevent repeated redirects
                if (typeof window !== 'undefined') {
                    window.sessionStorage.setItem('admin_redirecting_to_login', 'true');
                    
                    // Check current path before redirecting
                    const currentPath = window.location.pathname;
                    if (!currentPath.includes('/siteadmin/login')) {
                        // Redirect to login page with a timestamp to force reload
                        const timestamp = Date.now();
                        window.location.href = `/siteadmin/login?t=${timestamp}`;
                    }
                }
                
                return true;
            } else {
                dispatch({
                    type: ADMIN_USER_LOGOUT_ERROR
                });
            }
        } catch (error) {
            dispatch({
                type: ADMIN_USER_LOGOUT_ERROR,
                payload: {
                    error
                }
            });
            return false;
        }
        return true;
    }
}